import { ProgressBar } from './progress-bar';
import { ProgressRange } from './progress-range';
import { ProgressRoot } from './progress-root';
import { ProgressTrack } from './progress-track';

export const Progress = {
  Root: ProgressRoot,
  Bar: ProgressBar,
  Range: ProgressRange,
  Track: ProgressTrack,
};
